import React from 'react'

const Cp_selection = () => {
    return (
        <div className='container'>
            <h1>Selection Sort</h1>
            <p>The selection sort algorithm sorts an array by repeatedly finding the minimum element (considering ascending order) from unsorted part and putting it at the beginning. The algorithm maintains two subarrays in a given array.</p>
            <p>1) The subarray which is already sorted.<br/>
            2) Remaining subarray which is unsorted.</p>
            <p>In every iteration of selection sort, the minimum element (considering ascending order) from the unsorted subarray is picked and moved to the sorted subarray.</p>
            <p>Following example explains the above steps:</p>
            <br />
            <div className='output'>arr[] = 64 25 12 22 11 <br />
 <br />
// Find the minimum element in arr[0...4] <br />
// and place it at beginning <br />
<strong>11 </strong>25 12 22 64 <br />
 <br />
// Find the minimum element in arr[1...4] <br />
// and place it at beginning of arr[1...4] <br />
11 <strong>12 </strong>25 22 64 <br />
 <br />
// Find the minimum element in arr[2...4] <br />
// and place it at beginning of arr[2...4] <br />
11 12 <strong>22 </strong>25 64 <br />
 <br />
// Find the minimum element in arr[3...4] <br />
// and place it at beginning of arr[3...4] <br />
11 12 22 <strong>25 </strong>64 </div> <br />
<div class="containers">
   
        <div class="line number2 index1 alt1"><code class="library">#include &lt;iostream&gt;</code></div>
        <div class="line number3 index2 alt2"><code class="keywords">using</code> <code
                        class="keywords">namespace</code> <code class="plain">std;</code></div>
        <div class="line number4 index3 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number5 index4 alt2"><code class="keywords">void</code> <code
                        class="plain">swap(</code><code class="color1 bold">int</code> <code
                        class="plain">*xp, </code><code class="color1 bold">int</code> <code
                        class="plain">*yp)&nbsp;</code></div>
        <div class="line number6 index5 alt1"><code class="plain">&#123;&nbsp;</code></div>
        <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="color1 bold">int</code> <code class="plain">temp = *xp;&nbsp;</code></div>
        <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">*xp = *yp;&nbsp;</code></div>
        <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">*yp = temp;&nbsp;</code></div>
        <div class="line number10 index9 alt1"><code class="plain">&#125;&nbsp;</code></div>
        <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number12 index11 alt1"><code class="keywords">void</code> <code
                        class="plain">selectionSort(</code><code class="color1 bold">int</code> <code
                        class="plain">arr[], </code><code class="color1 bold">int</code> <code
                        class="plain">n)&nbsp;</code></div>
        <div class="line number13 index12 alt2"><code class="plain">&#123;&nbsp;</code></div>
        <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="color1 bold">int</code> <code class="plain">i, j, min_idx;&nbsp;</code></div>
        <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// One by one move boundary of unsorted subarray&nbsp;</code></div>
        <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">for</code> <code class="plain">(i = 0; i &lt; n-1; i++)&nbsp;</code></div>
        <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;&nbsp;</code></div>
        <div class="line number19 index18 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Find the minimum element in unsorted array&nbsp;</code></div>
        <div class="line number20 index19 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">min_idx = i;&nbsp;</code></div>
        <div class="line number21 index20 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">for</code> <code class="plain">(j = i+1; j &lt; n; j++)&nbsp;</code></div>
        <div class="line number22 index21 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">if</code> <code class="plain">(arr[j] &lt; arr[min_idx])&nbsp;</code></div>
        <div class="line number23 index22 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">min_idx = j;&nbsp;</code></div>
        <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number25 index24 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Swap the found minimum element with the first element&nbsp;</code></div>
        <div class="line number26 index25 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">swap(&amp;arr[min_idx], &amp;arr[i]);&nbsp;</code></div>
        <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;&nbsp;</code></div>
        <div class="line number28 index27 alt1"><code class="plain">&#125;&nbsp;</code></div>
        <div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number30 index29 alt1"><code class="comment">/* Function to print an array */</code></div>
        <div class="line number31 index30 alt2"><code class="keywords">void</code> <code
                        class="plain">printArray(</code><code class="color1 bold">int</code> <code
                        class="plain">arr[], </code><code class="color1 bold">int</code> <code
                        class="plain">size)&nbsp;</code></div>
        <div class="line number32 index31 alt1"><code class="plain">&#123;&nbsp;</code></div>
        <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="color1 bold">int</code> <code class="plain">i;&nbsp;</code></div>
        <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">for</code> <code class="plain">(i=0; i &lt; size; i++)&nbsp;</code></div>
        <div class="line number35 index34 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; arr[i] &lt;&lt; </code><code class="string">" "</code><code
                        class="plain">;&nbsp;</code></div>
        <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; endl;&nbsp;</code></div>
        <div class="line number37 index36 alt2"><code class="plain">&#125;&nbsp;</code></div>
        <div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>

        <div class="line number40 index39 alt1"><code class="color1 bold">int</code> <code
                        class="plain">main()&nbsp;</code></div>
        <div class="line number41 index40 alt2"><code class="plain">&#123;&nbsp;</code></div>
        <div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="color1 bold">int</code> <code class="plain">arr[] = &#123;64, 25, 12, 22, 11&#125;;&nbsp;</code>
        </div>
        <div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="color1 bold">int</code> <code class="plain">n = </code><code
                        class="keywords">sizeof</code><code class="plain">(arr)/</code><code
                        class="keywords">sizeof</code><code class="plain">(arr[0]);&nbsp;</code></div>
        <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">selectionSort(arr, n);&nbsp;</code></div>
        <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; </code><code class="string">"Sorted array: \n"</code><code
                        class="plain">;&nbsp;</code></div>
        <div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">printArray(arr, n);&nbsp;</code></div>
        <div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">return</code> <code class="plain">0;&nbsp;</code></div>
        <div class="line number48 index47 alt1"><code class="plain">&#125;&nbsp;</code></div>
        <div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        
</div>
<div className='output'>
    <p><strong>Output:</strong></p>
Sorted array:  <br />
11 12 22 25 64
</div>
        </div>
    )
}

export default Cp_selection
